import { get } from 'lodash';

export const isSnackbarOpenSelector = state => Boolean( get( state, 'snackbar.type', false ) );
export const snackbarTypeSelector = state => get( state, 'snackbar.type', null );
export const snackbarAdditionalOptionsSelector = state => get( state, 'snackbar.additionalOptions', {} );
